export default __webpack_public_path__ + "slices/main/assets/public/fonts/inter/inter-medium.cc6a88688869161eb83642d9393a0c2d.woff";